import { type CoordinateFormat, defaultCoordinateFormat } from '@gmn-portal/backend';
import { useAuth } from '@/core/auth';

export const useCoordinateFormat = (): CoordinateFormat => {
  const { user } = useAuth();
  return user?.coordinateFormatPreference ?? defaultCoordinateFormat;
};
